import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container
} from "react-bootstrap";
import { appConfig } from "../../config";
import InvoiceImageView from "./InvoiceImageView";
import ModalImage from "react-modal-image";
import PDFViewer from "pdf-viewer-reactjs";
var dateFormat = require("dateformat");

class ViewInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceImgModal: false
    };
    this.mouseOver = this.mouseOver.bind(this);
  }

  mouseOver = data => {
    this.setState({ invoiceImgModal: true, ImageData: data });
  };

  closeImgModel = () => {
    this.setState({ invoiceImgModal: false });
  };

  getExtension = filename => {
    return filename.split(".").pop();
  };

  render() {
    const data =
      this.props.invoiceDetail && this.props.invoiceDetail.item
        ? this.props.invoiceDetail && this.props.invoiceDetail.item
        : null;

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            //size="sm"
            backdrop="static"
            style={{ backgroundColor: "#00000010" }}
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white"
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Invoice Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="profilebasicdetailscont">
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Reference Number
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data !== null && data.invNo}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Order Number
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data && data.orderId && data.orderId.orderNo}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Created By
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data && data.dstbtrDtls && data.dstbtrDtls.name}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Pharmacy
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data && data.chmstDtls && data.chmstDtls.name}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Payment Mode
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data && data.orderId && data.orderId.payMode}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Payment Status
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data !== null && data.status}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Amount
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data !== null && data.amount?"INR "+data.amount:null}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Created Date & Time
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p  className="cmn_Cap" >
                          {data !== null &&
                          data.createdAt !== null &&
                          dateFormat(data.createdAt, "dd/mm/yyyy, h:MM TT")}
                        </p>
                      </Col>
                    </Row>

                  </Col>

                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Invoice Preview
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <div>
                          {data && data.imgUrl ? (
                            this.getExtension(data.imgUrl) === "pdf" ? (
                              /* (<PDFViewer
                                document={{
                                    url: data && data.imgUrl&&(appConfig.imgServerip+`/getInvImg?imgName=${data.imgUrl}`),
                                }}
                              />) */
                              <div>
                                <Image
                                  className="ctgryImg"
                                  style={{cursor:"pointer"}}
                                  src={[
                                    data && data.imgUrl !== undefined
                                      ? require("../../assets/img/default_pdf_icon.png")
                                      : "No Preview"
                                  ]}
                                  onClick={() =>
                                    data.imgUrl !== undefined
                                      ? this.mouseOver({ data: data.imgUrl })
                                      : null
                                  }
                                />
                                <InvoiceImageView
                                  show={this.state.invoiceImgModal}
                                  handleClose={this.closeImgModel}
                                  ImageData={this.state.ImageData}
                                />
                              </div>
                            ) : (
                              <ModalImage
                                small={
                                  data &&
                                  data.imgUrl &&
                                  appConfig.imgServerip +
                                    `/getInvImg?imgName=${data.imgUrl}`
                                }
                                large={
                                  data &&
                                  data.imgUrl &&
                                  appConfig.imgServerip +
                                    `/getInvImg?imgName=${data.imgUrl}`
                                }
                                hideDownload={true}
                                hideZoom={true}
                                className="ctgryImg"
                              />
                            )
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
{/*                 <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Reference Number{" "}
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.invNo}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Order Number
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.orderId && data.orderId.orderNo}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Raised By
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.dstbtrDtls && data.dstbtrDtls.name}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Raised Against
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.chmstDtls && data.chmstDtls.name}
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Payment Mode
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.orderId && data.orderId.payMode}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">Amount</p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.amount?"INR "+data.amount:null}
                      </p>
                    </div>
                  </Col>

                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">Preview</p>
                      <p className="profilebasicdetailscontper">
                        {data && data.imgUrl ? (
                          this.getExtension(data.imgUrl) === "pdf" ? (
                            <div>
                              <Image
                                className="ctgryImg"
                                style={{cursor:"pointer"}}
                                src={[
                                  data && data.imgUrl !== undefined
                                    ? require("../../assets/img/default_pdf_icon.png")
                                    : "No Preview"
                                ]}
                                onClick={() =>
                                  data.imgUrl !== undefined
                                    ? this.mouseOver({ data: data.imgUrl })
                                    : null
                                }
                              />
                              <InvoiceImageView
                                show={this.state.invoiceImgModal}
                                handleClose={this.closeImgModel}
                                ImageData={this.state.ImageData}
                              />
                            </div>
                          ) : (
                            <ModalImage
                              small={
                                data &&
                                data.imgUrl &&
                                appConfig.imgServerip +
                                  `/getInvImg?imgName=${data.imgUrl}`
                              }
                              large={
                                data &&
                                data.imgUrl &&
                                appConfig.imgServerip +
                                  `/getInvImg?imgName=${data.imgUrl}`
                              }
                              hideDownload={true}
                              hideZoom={true}
                              className="ctgryImg"
                            />
                          )
                        ) : null}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Created Date & Time
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null &&
                          data.createdAt !== null &&
                          dateFormat(data.createdAt, "mmmm dS, yyyy, h:MM TT")}
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Payment Status
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.status}
                      </p>
                    </div>
                  </Col>
                </Row>
 */}              </div>
            </Modal.Body>
            {/* <Modal.Footer style={{ backgroundColor: "#1768B7" }}></Modal.Footer> */}
          </Modal>
        </div>
      </div>
    );
  }
}

export default ViewInvoice;
